<template>
  <b-container fluid
               class="px-3">
    <esg-base-card title="제품 생애주기 온실가스 배출량"
                   :footer="false">
      <template #actions>
        <b-row align-h="end"
               class="flex-fill">
          <b-col sm="6">
            <!-- Product family search form -->
            <b-input-group>
              <b-form-input placeholder="제품군을 선택해주세요"
                            readonly
                            v-model="productFamily.name"
                            v-b-modal.product-family-search/>
            </b-input-group>
            <!-- /Product family search form -->
          </b-col>
          <b-col sm="6"
                 class="mt-2 mt-sm-0">
            <!-- Product search box -->
            <b-input-group>
              <b-form-input placeholder="제품을 선택해주세요"
                            readonly
                            v-model="product.name"
                            @click="openProductSearch"/>
            </b-input-group>
            <!-- /Product search box -->
          </b-col>
        </b-row>
      </template>

      <!-- No data -->
      <div v-if="thereIsNoData"
           class="d-flex align-items-center justify-content-center"
           style="height: 500px">
        <span style="font-size: 1.125rem; font-family: NanumGothic">제품 생애주기 온실가스 배출량 조회를 위해 제품군을 선택해주세요.</span>
      </div>
      <!-- /No data -->

      <!-- Product family information -->
      <lca-product-family-detail v-show="productFamily.code && (!product.productFamilyCode || !product.productCode)"
                                 :product-family="productFamily"
                                 @productSelected="onProductSelected"
                                 @noData="handleDataError"/>
      <!-- /Product family information -->

      <!-- Product detail -->
      <lca-product-detail v-show="productFamily.code && product.productFamilyCode && product.productCode"
                          :productFamily="productFamily"
                          :product="product"
                          @noData="handleDataError"/>
      <!-- /Product detail -->

      <!-- Product family search modal -->
      <esg-base-dashboard-modal id="product-family-search"
                                size="lg"
                                title="제품군 선택">
        <esg-base-list name="esg_base_product_family"
                       @rowClicked="setProductFamily"/>
      </esg-base-dashboard-modal>
      <!-- /Product family search modal -->

      <!-- Product search modal -->
      <esg-base-dashboard-modal id="product-search"
                                size="lg"
                                title="제품 선택">
        <esg-base-list name="product"
                       :fixed-filter="productFilter"
                       @rowClicked="setProduct"/>
      </esg-base-dashboard-modal>
      <!-- /Product search modal -->
    </esg-base-card>
  </b-container>
</template>
<script>
import LcaProductFamilyDetail from '../../dashboardCards/LcaProductFamilyDetail.vue'
import LcaProductDetail from '../../dashboardCards/LcaProductDetail.vue'
import EsgBaseCard from "@/components/esg/base/EsgBaseCard.vue";
import EsgBaseList from "@/components/esg/base/EsgBaseList.vue";
import EsgBaseDashboardModal from "@/components/esg/base/EsgBaseDashboardModal.vue";

export default {
  components: {
    EsgBaseDashboardModal,
    EsgBaseList,
    EsgBaseCard,
    LcaProductFamilyDetail,
    LcaProductDetail,
  },
  data() {
    return {
      loading: false,
      product: { productFamilyCode: null, productCode: null, name: null },
      productFamily: { code: null, name: null },
      productFilter: []
    }
  },
  computed: {
    thereIsNoData() {
      return !this.productFamily.code || !this.productFamily.name
    }
  },
  watch: {},
  methods: {
    async openProductSearch() {
      if (this.productFamily.name && this.productFamily.code) {
        this.$bvModal.show('product-search')
      } else {
        await this.showError(new Error('제품군을 먼저 선택해주세요.'));
      }
    },
    setProductFamily(productFamily) {
      this.productFamily = productFamily;
      this.product = { productFamilyCode: null, productCode: null, name: null };
      this.productFilter = [
        {
          name: 'esg_base_product_family.tenant_id',
          operation: 'EQUAL',
          value: this.tenantId()
        },
        {
          name: 'esg_base_product_family.code',
          operation: 'EQUAL',
          value: this.productFamily.code
        }
      ];
      this.$bvModal.hide('product-family-search')
    },
    setProduct(product) {
      this.product = {
        productFamilyCode: product.esg_base_product_product_family_code,
        productCode: product.esg_base_product_product_code,
        name: product.esg_base_product_name,
      }
      this.$bvModal.hide('product-search')
    },
    onProductSelected(product) {
      this.product = product;
    },
    async handleDataError() {
      this.product = { productFamilyCode: null, productCode: null, name: null };
      this.productFamily = { code: null, name: null };
      await this.showError(new Error("데이터가 존재하지 않습니다."))
    },
  }
}
</script>

<style scoped>
>>> .card .card-body {
  padding: 1vh 1vw;
}

>>> .table thead th,
>>> .table tbody td {
  font-size: 0.875rem !important;
}

/* 상단 상품군 검색 및 상품 선택 */
.custom-select {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.custom-select:focus {
  border-color: #E7E7EE;
  box-shadow: unset;
}

.form-control {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150% !important;
  margin-bottom: 0;
}

.form-control[readonly] {
  background-color: #F6F6FA;
}

.form-control:focus {
  box-shadow: none;
  border-color: unset;
}

button.btn.btn-outline-secondary {
  box-shadow: none !important;
  border-color: #E7E7EE !important;
}
</style>
